import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'

interface Props {
  year: number;
}

function AccommodationCalendarMonthHeader(props: Props) {
  const { year } = props
  return <div>
    <Heading variant="heading5">{year}</Heading>
  </div>
}

export default AccommodationCalendarMonthHeader
